import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  imports: [],
  templateUrl: './confirm-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialog {
  readonly isOpen = input(false);
  readonly title = input('Conferma operazione');
  readonly message = input('Sei sicuro di voler procedere?');
  readonly confirmLabel = input('Conferma');
  readonly cancelLabel = input('Annulla');
  readonly isConfirmDisabled = input(false);

  readonly confirmed = output<void>();
  readonly cancelled = output<void>();
}
